import React from 'react'
import exact from 'prop-types-exact'
import { BookIcon } from 'components/icons'

const propTypes = {}

const defaultProps = {}

function OpenToSchoolPartnershipsIndicator() {
  return (
    <div className="flex-horizontal open-to-partnerships">
      <div className="star-icon">
        <BookIcon aria-hidden />
      </div>
      <p>
        <strong>Open to Partnerships with Schools</strong>
      </p>
    </div>
  )
}

OpenToSchoolPartnershipsIndicator.propTypes = exact(propTypes)
OpenToSchoolPartnershipsIndicator.defaultProps = defaultProps

export default React.memo(OpenToSchoolPartnershipsIndicator)
